import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../../theme'

const notificationFilterListStyles: IStyles = {
    filterOptions: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
        marginBottom: 14,
        padding: '8px 10px',
        borderRadius: 4,
        backgroundColor: colors.white,
    },
    filterItem: {
        display: 'flex',
    },
}

addStyles(notificationFilterListStyles)
export default notificationFilterListStyles
